import { GITHUB_API_HOST_URL } from '../../constant';
// To Get User Repos
export const getUserRepos = async () => {
    const params = new URLSearchParams({
        sort: 'created',
        per_page: 6,
    })
    const response = await fetch(`${GITHUB_API_HOST_URL}/users/molla-mainuddin/repos?${params}`);
    const data = await response.json();
    // console.log(data)
    return data;
}